import type { Difficulty, LocalizedText, ProblemStatus, User } from '@/types';
import type { ApiDifficulty, ApiSolveStatus, ProblemSummaryResponse, UserResponse } from './types';

export function mapDifficulty(d: ApiDifficulty): Difficulty {
  return d.toLowerCase() as Difficulty;
}

/** Progress xaritasida yo'q masala — hali urinilmagan (todo). */
export function mapSolveStatus(status: ApiSolveStatus | undefined): ProblemStatus {
  if (status === 'SOLVED') return 'solved';
  if (status === 'ATTEMPTED') return 'attempted';
  return 'todo';
}

export function mapUser(dto: UserResponse): User {
  return {
    id: dto.id,
    name: dto.displayName ?? dto.username,
    username: dto.username,
    email: dto.email,
    avatarUrl: dto.avatarUrl ?? undefined,
    isPremium: dto.premium,
    isAdmin: dto.role === 'ADMIN',
    premiumExpiresAt: dto.premiumExpiresAt ?? undefined,
    joinedAt: dto.createdAt,
  };
}

/**
 * Backend list javobi `topics` ni qaytaradi (kanonik nomlar: JOIN, WINDOW, ...).
 * `companies` esa faqat detail endpoint'da bor — list'da bo'sh qoladi.
 *
 * `status` esa alohida `/me/progress` dan keladi: list endpoint public, progress esa
 * foydalanuvchiga bog'liq. Kirmagan foydalanuvchi uchun `undefined` → 'todo'.
 */
export function mapProblemSummary(dto: ProblemSummaryResponse, status?: ApiSolveStatus) {
  const title: LocalizedText = { uz: dto.titleUz, ru: dto.titleRu, en: dto.titleEn };
  return {
    id: dto.id,
    slug: dto.slug,
    title,
    difficulty: mapDifficulty(dto.difficulty),
    topics: dto.topics ?? [],
    companies: [] as string[],
    // null — hali hech kim jo'natmagan; 0 ga aylantirilsa "hamma yiqilgan" bo'lib ko'rinadi
    acceptance: dto.acceptanceRate != null ? Math.round(dto.acceptanceRate) : null,
    isPremium: dto.isPremium,
    status: mapSolveStatus(status),
  };
}
